module.exports = __webpack_public_path__ + "media/images/icons/mobile-xx-9bc71f2f710e60305360d3a5c676a336.svg";